import React from 'react';
import { Breakpoint } from '@moda/om';
import { ProductDetailsFragment, SizeInventoryFragment } from '../../../generated/types';
import { ProductDetailsFavoriteSectionDesktop } from './ProductDetailsFavoriteSectionDesktop';
import { ProductDetailsFavoriteSectionMobile } from './ProductDetailsFavoriteSectionMobile';

interface Props {
  variant: ProductDetailsFragment;
  size: SizeInventoryFragment | null;
}

export const ProductDetailsFavoriteSection: React.FC<Props> = ({ variant, size }) => (
  <>
    <Breakpoint gt="sm">
      <ProductDetailsFavoriteSectionDesktop variant={variant} />
    </Breakpoint>

    <Breakpoint lt="sm">
      <ProductDetailsFavoriteSectionMobile size={size} variant={variant} />
    </Breakpoint>
  </>
);
